import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './lib/auth';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/ui/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Finance from './pages/Finance';
import Inventory from './pages/Inventory';
import Anomalies from './pages/Anomalies';
import Trends from './pages/Trends';
import Config from './pages/Config';
import Prediccion from './pages/Prediccion';

function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />

      {/* Rutas protegidas con AppLayout */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/anomalies" element={<Anomalies />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/predict" element={<Prediccion />} />
        <Route path="/config" element={<Config />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
